import type { ReactNode } from 'react';

/** The landing page's few icons, inline: no icon font or library in its bundle. Decorative. */
const Svg = ({ size = 20, children }: { size?: number; children: ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

export const MenuIcon = () => (
  <Svg>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const CloseIcon = () => (
  <Svg>
    <path d="M6 6l12 12M18 6 6 18" />
  </Svg>
);

export const ArrowDownIcon = ({ size = 24 }: { size?: number }) => (
  <Svg size={size}>
    <path d="M12 4v15M6 13l6 6 6-6" />
  </Svg>
);

export const ArrowRightIcon = ({ size = 20 }: { size?: number }) => (
  <Svg size={size}>
    <path d="M4 12h15M13 6l6 6-6 6" />
  </Svg>
);

export const ChevronDownIcon = () => (
  <Svg size={18}>
    <path d="m6 9 6 6 6-6" />
  </Svg>
);

/** A chat bubble: the WhatsApp button's mark, without borrowing WhatsApp's logo. */
export const ChatIcon = () => (
  <Svg size={18}>
    <path d="M12 3C7 3 3 6.6 3 11c0 2 .8 3.9 2.3 5.3L4.5 21l4.3-1.4c1 .3 2.1.4 3.2.4 5 0 9-3.6 9-8s-4-9-9-9Z" />
  </Svg>
);
